import { type PropsWithChildren } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

//#region Typings

/**
 * Accepted properties for the Select EmptyState
 * @public
 */
export type SelectV2EmptyStateProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId;
//#endregion

/**
 * The `SelectV2.EmptyState` component allows you to specify any content, that should
 * be shown when no select options are available. The `SelectV2.EmptyState` component
 * is only valid within the `SelectV2.Content` element.
 * @example
 * ```tsx
 * <SelectV2.Content>
 *   <SelectV2.EmptyState>
 *     No items found.
 *   </SelectV2.EmptyState>
 * </SelectV2.Content>
 * ```
 * @public
 */
export function SelectV2EmptyState(props: SelectV2EmptyStateProps): null {
  return null;
}
